import React from 'react';
import get from 'lodash/get';
import {ErrorMessage, FastField, Field} from 'formik';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';
import Error from '../Error';
import PlusButton from './editor/PlusButton';
import MinusButton from './editor/MinusButton';

const SurveyEditorRangeColors = ({form, name, push, remove}) => {
    const values = get(form.values, name) || [];

    const addItem = React.useCallback(() => {
        push({value: 1, color: '#000000'});
    }, [push]);

    if (values.length > 0) {
        return (
            <table className="table table-sm table-borderless">
                <colgroup>
                    <col />
                    <col style={{width: 50}} />
                </colgroup>
                <thead>
                    <tr>
                        <th className="pl-0"><FormattedMessage {...messages.surveys.form.label.rangesColors.to} /></th>
                        <th className="pl-0"><FormattedMessage {...messages.surveys.form.label.rangesColors.color} /></th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {values.map((item, index) => (
                        <tr key={index}>
                            <td className="pl-0">
                                <FastField id={`${name}.${index}.value`} name={`${name}.${index}.value`} type="number" max="100" min="0" step="1"
                                    className={classNames('form-control',
                                        {error: get(form.errors, `${name}.${index}.value`) && get(form.touched, `${name}.${index}.value`)})} />
                                <ErrorMessage name={`${name}.${index}.value`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            </td>
                            <td className="pl-0">
                                <Field id={`${name}.${index}.color`} name={`${name}.${index}.color`} type="color" className="form-control" />

                                <ErrorMessage name={`${name}.${index}.color`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            </td>
                            <td>
                                <div className="d-flex justify-content-center">
                                    <div className="flex-column">
                                        <MinusButton remove={remove} index={index} />
                                    </div>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan="4" className="pl-0">
                            <PlusButton onClick={addItem}>
                                <FormattedMessage {...messages.surveys.form.label.rangesColors.addRangeColor} />
                            </PlusButton>
                        </td>
                    </tr>
                </tfoot>
            </table>);
    } else {
        return (
            <PlusButton onClick={addItem}>
                <FormattedMessage {...messages.surveys.form.label.rangesColors.addRangeColor} />
            </PlusButton>);
    }
};

export default SurveyEditorRangeColors;
